export default __webpack_public_path__ + "static/media/9.4f9f75b7.md";